module.exports = __webpack_public_path__ + "img/1.310b7edd.png";